import { render } from "./ExpiryBadge.vue?vue&type=template&id=062a9999&scoped=true"
import script from "./ExpiryBadge.vue?vue&type=script&lang=js"
export * from "./ExpiryBadge.vue?vue&type=script&lang=js"

import "./ExpiryBadge.vue?vue&type=style&index=0&id=062a9999&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062a9999"]])

export default __exports__